import React from 'react';
import { Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import useRequest from '@hooks/useRequest';
import * as assets from '@assets';
import useStyles from './useStyles';
import { CapaQuotationServiceType } from '@generated/graphql';
import { clsx } from '@components/Provider';

const RequestForQuotationSheetMetalService = () => {
  const classes = useStyles();
  const {
    requestState: { optionalServices },
    onUpdateRfqInfo
  } = useRequest();
  const isBD =
    optionalServices &&
    optionalServices.findIndex(
      (v) => v && v.serviceType === CapaQuotationServiceType.Bending
    ) !== -1;

  const isWD =
    optionalServices &&
    optionalServices.findIndex(
      (v) => v && v.serviceType === CapaQuotationServiceType.Weilding
    ) !== -1;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isExist =
      optionalServices &&
      optionalServices.findIndex(
        (v) =>
          v && v.serviceType === (event.target.name as CapaQuotationServiceType)
      ) !== -1;

    if (isExist) {
      onUpdateRfqInfo({
        optionalServices: [
          ...(optionalServices ?? []).filter(
            (v) =>
              v &&
              v.serviceType !== (event.target.name as CapaQuotationServiceType)
          )
        ]
      });
      return;
    }

    onUpdateRfqInfo({
      optionalServices: [
        ...(optionalServices ?? []),
        {
          serviceType: event.target.name as CapaQuotationServiceType,
          quantity: 0
        }
      ]
    });
  };

  return (
    <Grid
      container
      component="section"
      className={clsx(classes['rfq-sheetMetal'], classes['rfq-info-section'])}
    >
      <CustomizedTypography
        className="title"
        align="center"
        color="textPrimary"
        gutterBottoms={40}
      >
        판금 가공과 함께 진행할 서비스를 선택해주세요 (복수 선택 가능)
      </CustomizedTypography>

      <Grid item className="extensionRoot">
        <FormControlLabel
          classes={{
            root: !isBD ? 'extensionBox' : `${'extensionBox'} checked`,
            label: 'FormControlLabel'
          }}
          label={
            <React.Fragment>
              <CustomizedTypography className="primaryText">
                + 밴딩 가공
              </CustomizedTypography>
              <CustomizedTypography align="center">
                장비를 이용하여 금속 판재를 절곡합니다.
              </CustomizedTypography>
              <img
                src={assets.Banding}
                alt=""
                className="relatedServiceImage"
              />
            </React.Fragment>
          }
          control={
            <Checkbox
              onChange={handleChange}
              name={CapaQuotationServiceType.Bending}
              checked={Boolean(isBD)}
              color="primary"
              size="small"
            />
          }
        />
        <FormControlLabel
          classes={{
            root: !isWD ? 'extensionBox' : `${'extensionBox'} checked`,
            label: 'FormControlLabel'
          }}
          label={
            <React.Fragment>
              <CustomizedTypography className="primaryText">
                + 용접 가공
              </CustomizedTypography>
              <CustomizedTypography align="center">
                두 개의 금속을 고열을 가해 접합시킵니다.
              </CustomizedTypography>
              <img
                src={assets.Welding}
                alt=""
                className="relatedServiceImage"
              />
            </React.Fragment>
          }
          control={
            <Checkbox
              onChange={handleChange}
              name={CapaQuotationServiceType.Weilding}
              checked={Boolean(isWD)}
              color="primary"
              size="small"
            />
          }
        />
      </Grid>
    </Grid>
  );
};

export default RequestForQuotationSheetMetalService;
